import ContentList from '@components/UserProfilePage/ContentList'
import ContentListItem from '@components/UserProfilePage/ContentList/ContentListItem'
import LeserreporterEntryPoint from '@components/UserProfilePage/LeserreporterEntryPoint'
import OnboardingMessage from '@components/UserProfilePage/OnboardingMessage'
import ThemeSwitcher from '@components/UserProfilePage/ThemeSwitcher'
import Wrapper from '@components/UserProfilePage/Wrapper'

const exports = {
  OnboardingMessage,
  ContentList,
  ContentListItem,
  LeserreporterEntryPoint,
  Wrapper,
  ThemeSwitcher,
}

export default exports
